import { Helper } from '@/mixin/helper'
import store from '@/state/store'
const hasAccess = store.getters['identity/hasAccess']

export default [
  // Setting Home Page New
  {
    path: '/setting/',
    name: 'Setting',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'c1a-default-setpengguna:read',
            'c2a-default-setkaryawan:read',
            'c3a-default-setkendaraan:read',
            'c4a-default-setumum:read',
            'c5a-default-setgrupkendaraan:read',
            'vehicle_odometer:read',
            'c7a-default-setpengembang:read',
            'c8a-default-set-profil-perusahaan:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting/index-v2'),
  },
  // Setting Home Page Deprecated (Old Design)
  {
    path: '/setting-deprecated/',
    name: 'Setting Deprecated',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'c1a-default-setpengguna:read',
            'c2a-default-setkaryawan:read',
            'c3a-default-setkendaraan:read',
            'c4a-default-setumum:read',
            'c5a-default-setgrupkendaraan:read',
            'vehicle_odometer:read',
            'c7a-default-setpengembang:read',
            'c8a-default-set-profil-perusahaan:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting'),
  },
  {
    path: '/subsetting/',
    name: 'Sub Setting',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting/subsetting'),
  },
  {
    path: '/setting/template/delivery-order/',
    name: 'Setting Template Delivery Order',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'tms:create',
          'tms:read',
          'tms:update',
          'tms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/template/delivery-order'),
  },
  {
    path: '/setting/template/delivery-order/create',
    name: 'Setting Template Delivery Order Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'tms:create',
          'tms:read',
          'tms:update',
          'tms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "setting" */ '@/router/views/setting/template/delivery-order/detail'
      ),
  },
  {
    path: '/setting/template/delivery-order/:id',
    name: 'Setting Template Delivery Order Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'tms:create',
          'tms:read',
          'tms:update',
          'tms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "setting" */ '@/router/views/setting/template/delivery-order/detail'
      ),
  },
  {
    path: '/setting/template/fleet-task-expense/',
    name: 'Setting Fleet Task Expense',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'financial-record:create',
          'financial-record:read',
          'financial-record:update',
          'financial-record:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "setting" */ '@/router/views/setting/template/fleet-task-expense'
      ),
  },
  {
    path: '/setting/template/fleet-task-expense/create',
    name: 'Create Fleet Task Expense',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'financial-record:create',
          'financial-record:read',
          'financial-record:update',
          'financial-record:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "setting" */ '@/router/views/setting/template/fleet-task-expense/create'
      ),
  },
  {
    path: '/setting/template/fleet-task-expense/:id',
    name: 'Detail Fleet Task Expense',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'financial-record:create',
          'financial-record:read',
          'financial-record:update',
          'financial-record:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "setting" */ '@/router/views/setting/template/fleet-task-expense/create'
      ),
  },

  // Setting User Setting
  {
    path: '/setting/user/',
    name: 'List User Setting',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'c1a-default-setpengguna:read',
            'ugroups:read',
            'mgroups:read',
            'vgroups:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting/user'),
  },

  // Setting Create Group User
  {
    path: '/setting/user/groupcreate',
    name: 'Create Setting Group User',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'c1a-default-setpengguna:read',
            'ugroups:create',
            'mgroups:read',
            'vgroups:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/user/GroupCreate'),
  },

  // Detail User Group setting
  {
    path: '/setting/user/groupupdate/:id',
    name: 'Update Setting Group User',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'c1a-default-setpengguna:read',
            'ugroups:update',
            'mgroups:read',
            'vgroups:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/user/GroupCreate'),
  },

  // Setting Employee Setting
  {
    path: '/setting/employee/',
    name: 'List Employee Setting',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'c2a-default-setkaryawan:read',
            'company_structure:read',
            'employee_recruited_at:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting/employee'),
  },

  // Setting General Setting
  {
    path: '/setting/general/',
    name: 'List General Setting',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'c4a-default-setumum:read',
            'address_categories:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting/general'),
  },

  // Setting Company Profile
  {
    path: '/setting/company/',
    name: 'List Company Profile Setting',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'c8a-default-set-profil-perusahaan:read',
            'company:read',
            'geofences:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting/company'),
  },
  {
    path: '/setting/company/address',
    name: 'Company Profile Address',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'c8a-default-set-profil-perusahaan:read',
            'company:create',
            'geofences:create',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/master/address/form'),
  },
  {
    path: '/setting/company/address/:id',
    name: 'Company Profile Address Update',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'c8a-default-set-profil-perusahaan:read',
            'company:update',
            'geofences:update',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/master/address/form'),
  },

  // Setting Fleet Group Setting
  {
    path: '/setting/fleetgroup',
    name: 'List Fleet Group Setting',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'c5a-default-setgrupkendaraan:read',
            'vgroups:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting/fleetgroup'),
  },

  // Detail Fleet Group setting
  {
    path: '/setting/fleetgroup/update/:id',
    name: 'Fleet Group Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'c5a-default-setgrupkendaraan:read',
            'vgroups:update',
            'vehicles:read',
            'vehicle_categories:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/fleetgroup/form'),
  },

  // Setting Form Fleet Group Setting
  {
    path: '/setting/fleetgroup/create',
    name: 'Form Fleet Group',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'c5a-default-setgrupkendaraan:read',
            'vgroups:create',
            'vehicles:read',
            'vehicle_categories:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/fleetgroup/form'),
  },

  // Setting Fleet
  {
    path: '/setting/fleet/',
    name: 'List Fleet Setting',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['c3a-default-setkendaraan:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting/fleet'),
  },

  // Setting Maintenance
  {
    path: '/setting/maintenance',
    name: 'List Maintenance Setting',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting/maintenance'),
  },
  {
    path: '/setting/maintenance/log/:type',
    name: 'Log Maintenance Setting',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/maintenance/logHistory'),
  },

  // Setting Odometer
  {
    path: '/setting/odometer',
    name: 'List Odometer Setting',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'vehicle_odometer:read',
            'vehicle_odometer:update',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting/odometer'),
  },

  {
    path: '/setting/maintenance/parts',
    name: 'Setting Service Parts',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/maintenance/parts'),
  },

  {
    path: '/setting/live-view',
    name: 'Setting Live View',
    meta: {
      authRequired: true,
      hasAccess: Helper.methods.getAccessRight(),
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting/liveview'),
  },

  {
    path: '/setting/maintenance/service',
    name: 'Setting Service Activity',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/maintenance/service'),
  },

  {
    path: '/setting/maintenance/service/upload',
    name: 'Import Service Activity',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "setting" */ '@/router/views/setting/maintenance/service/importComponentService'
      ),
  },

  {
    path: '/setting/token',
    name: 'Setting Token',
    meta: {
      authRequired: true,
      hasAccess: Helper.methods.getAccessRight(),
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting/token'),
  },

  // Setting Token API
  {
    path: '/setting/token-api',
    name: 'Setting Token API',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'c7a-default-setpengembang:read',
            'generate_public_api_key:create',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting/development'),
  },

  {
    path: '/setting/token-api/v1',
    name: 'Setting Token API V1',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'c7a-default-setpengembang:read',
            'generate_public_api_key:create',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/development/token-v1'),
  },

  {
    path: '/setting/token-api/v2',
    name: 'Setting Token API V2',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'c7a-default-setpengembang:read',
            'generate_public_api_key:create',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/development/token-v2'),
  },

  // Setting Additional Cost
  {
    path: '/setting/additional-cost/',
    name: 'Setting Additional Cost',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'vms:create',
          'vms:read',
          'vms:update',
          'vms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/additional-cost'),
  },

  // Setting Product
  {
    path: '/setting/product/',
    name: 'Setting Product',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'tms:create',
          'tms:read',
          'tms:update',
          'tms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting/product'),
  },

  // Setting Delivery
  {
    path: '/setting/delivery/',
    name: 'Setting Delivery',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'tms:create',
          'tms:read',
          'tms:update',
          'tms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting/delivery'),
  },

  // Setting Fleet Task
  {
    path: '/setting/fleet-task/',
    name: 'Setting Fleet Task',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'tms:create',
          'tms:read',
          'tms:update',
          'tms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting/fleet-task'),
  },

  // Setting Tracker & Sensor
  {
    path: '/setting/tracker-sensor/',
    name: 'Setting Tracker & Sensor',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['set_idle_parking:read', 'set_fuel:read'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/tracker-sensor'),
  },

  // Setting Idle & Parking Time Limit
  {
    path: '/setting/tracker-sensor/idle-parking',
    name: 'Idle & Parking Limit Times',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['set_idle_parking:read'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "setting" */ '@/router/views/setting/tracker-sensor/idle-parking'
      ),
  },

  // Update Idle & Parking Time Limit
  {
    path: '/setting/tracker-sensor/idle-parking/update',
    name: 'Idle & Parking Limit Times Update',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccessAll']([
          'set_idle_parking:read',
          'set_idle_parking:update',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "setting" */ '@/router/views/setting/tracker-sensor/idle-parking/UpdateIdle'
      ),
  },

  // Fuel Sensor Setting
  {
    path: '/setting/tracker-sensor/fuel',
    name: 'Fuel Sensor Setting',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['set_fuel:read'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/tracker-sensor/fuel'),
  },

  // Fuel Sensor Setting
  {
    path: '/setting/tracker-sensor/fuel/update/:id',
    name: 'Update Fuel Sensor Setting',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccessAll'](['set_fuel:read', 'set_fuel:update'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "setting" */ '@/router/views/setting/tracker-sensor/fuel/UpdateFuel'
      ),
  },

  // Setting Management Whitelabel
  {
    path: '/setting/personalization/',
    name: 'Management Whitelabel',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'c13a-default-logo:read',
          'c13b-default-color:read',
          'c13c-default-banner:read',
          'c13d-default-contact:read',
        ])
        const isWhitelabel = store.getters['identity/isWhitelabel'](isWhitelabel)
        const isParent = store.getters['identity/isParent'](isParent)
        if (!acc || !isWhitelabel || !isParent) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/personalization'),
  },

  // Setting Management Color
  {
    path: '/setting/personalization/color',
    name: 'Management Color',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['c13b-default-color:read'])
        const isWhitelabel = store.getters['identity/isWhitelabel'](isWhitelabel)
        const isParent = store.getters['identity/isParent'](isParent)
        if (!acc || !isWhitelabel || !isParent) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/personalization/color'),
  },

  // Setting Management Logo
  {
    path: '/setting/personalization/logo',
    name: 'Management Logo',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['c13a-default-logo:read'])
        const isWhitelabel = store.getters['identity/isWhitelabel'](isWhitelabel)
        const isParent = store.getters['identity/isParent'](isParent)
        if (!acc || !isWhitelabel || !isParent) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/personalization/logo'),
  },

  // Setting Management Banner
  {
    path: '/setting/personalization/banner',
    name: 'Management Banner',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['c13c-default-banner:read'])
        const isWhitelabel = store.getters['identity/isWhitelabel'](isWhitelabel)
        const isParent = store.getters['identity/isParent'](isParent)
        if (!acc || !isWhitelabel || !isParent) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/personalization/banner'),
  },

  // Setting Management Kontak Perusahaan
  {
    path: '/setting/personalization/contact',
    name: 'Company Contact',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['c13d-default-contact:read'])
        const isWhitelabel = store.getters['identity/isWhitelabel'](isWhitelabel)
        const isParent = store.getters['identity/isParent'](isParent)
        if (!acc || !isWhitelabel || !isParent) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/personalization/contact'),
  },

  // Setting Management Sub-Domain
  {
    path: '/setting/asset/subDomain',
    name: 'Management Domain',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccessAll']([
          'c11b-default-subdomain:read',
          'c11b-default-subdomain:update',
        ])
        const isParent = store.getters['identity/isParent'](isParent)
        if (!acc || !isParent) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/asset/subDomain'),
  },
  // Setting Management GPS
  {
    path: '/setting/asset/gps',
    name: 'Management GPS',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['c11a-default-gps:read'])
        const isParent = store.getters['identity/isParent'](isParent)
        if (!acc || !isParent) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/asset/setGps'),
  },
  // Setting History GPS
  {
    path: '/setting/asset/gps/history/:imei',
    name: 'History GPS',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['c11a-default-gps:read'])
        const isParent = store.getters['identity/isParent'](isParent)
        if (!acc || !isParent) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "setting" */ '@/router/views/setting/asset/components/gps/historyGps'
      ),
  },
  {
    path: '/setting/cost-category/',
    name: 'Setting Cost Category',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'financial-record:create',
          'financial-record:read',
          'financial-record:update',
          'financial-record:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/cost-category'),
  },

  // Setting Management Asset
  {
    path: '/setting/asset/',
    name: 'Management Asset',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'c11a-default-gps:read',
          'c11b-default-subdomain:read',
        ])
        const isParent = store.getters['identity/isParent'](isParent)
        if (!acc || !isParent) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting/asset'),
  },

  // Setting Custom Field
  {
    path: '/setting/custom-field/',
    name: 'Setting Custom Field',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'tms:create',
          'tms:read',
          'tms:update',
          'tms:delete',
          'fleet-task-instant:create',
          'fleet-task-instant:read',
          'fleet-task-instant:update',
          'fleet-task-instant:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/custom-field'),
  },

  {
    path: '/setting/custom-field/delivery',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'tms:create',
          'tms:read',
          'tms:update',
          'tms:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    name: 'Setting Custom Field Delivery',
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/custom-field/delivery'),
  },

  {
    path: '/setting/custom-field/quick-assignment',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess']([
          'fleet-task-instant:create',
          'fleet-task-instant:read',
          'fleet-task-instant:update',
          'fleet-task-instant:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    name: 'Setting Custom Field Quick Assignment',
    component: () =>
      import(
        /* webpackChunkName: "setting" */ '@/router/views/setting/custom-field/quick-assignment'
      ),
  },

  {
    path: '/setting/webhook',
    name: 'Setting Webhook',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['webhook_api:read'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/setting/webhook'),
  },

  {
    path: '/setting/webhook/create',
    name: 'Create Webhook',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['webhook_api:create'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/webhook/form'),
  },

  {
    path: '/setting/webhook/update/:id',
    name: 'Update Webhook',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['webhook_api:update'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/webhook/form'),
  },

  {
    path: '/setting/webhook/detail/:id',
    name: 'Detail Webhook',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['webhook_api:read'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/webhook/WebhookDetail'),
  },

  {
    path: '/setting/notification',
    name: 'Setting Notification List',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['e4b-alert-center-rule-setting:read'])
        if (!acc) return next({ name: 'Notification Setting' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/notification'),
  },

  {
    path: '/setting/notification/create',
    name: 'Add Setting Notification',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['e4b-alert-center-rule-setting:create'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/notification/form'),
  },

  {
    path: '/setting/notification/detail/:id',
    name: 'Detail Setting Notification',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = store.getters['identity/hasAccess'](['e4b-alert-center-rule-setting:read'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/notification/form'),
  },

  {
    path: '/setting/engine-off/',
    name: 'Setting Engine Off Automation',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc =
          Helper.methods.getAccessRight() &&
          hasAccess([
            'c15a-cut-off-engine:read',
            'c15a-cut-off-engine:update',
            'c15a-cut-off-engine:delete',
          ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/cut-off/index.vue'),
  },

  {
    path: '/setting/engine-off/detail/:id',
    name: 'Detail Setting Engine Off Automation',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc =
          Helper.methods.getAccessRight() &&
          hasAccess(['c15a-cut-off-engine:read', 'c15a-cut-off-engine:update'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/cut-off/form.vue'),
  },

  {
    path: '/setting/engine-off/import/',
    name: 'Import Setting Engine Off Automation',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc =
          Helper.methods.getAccessRight() &&
          hasAccess([
            'c15a-cut-off-engine:create',
            'c15a-cut-off-engine:read',
            'c15a-cut-off-engine:update',
          ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/setting/cut-off/import/index.vue'),
  },

  {
    path: '/setting/engine-off/history/',
    name: 'History Setting Engine Off Automation',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = Helper.methods.getAccessRight() && hasAccess(['c15a-cut-off-engine:read'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "setting" */ '@/router/views/setting/cut-off/contents/HistoryTab'
      ),
  },
]
